import type {
  FidsRingType,
  FidsRingTypeOption,
} from 'contracts/FidsTrackingRoutes';
import { formatKm } from './format';
import * as S from './styles';

interface RingLegendProps {
  ringTypes: FidsRingTypeOption[];
  selectedType: FidsRingType;
  onSelectType: (type: FidsRingType) => void;
}

// Legenda sobre o mapa: os anéis mudam com o tipo do veículo, e o mapa mostra um tipo por vez.
export const RingLegend: React.FC<RingLegendProps> = ({
  ringTypes,
  selectedType,
  onSelectType,
}) => {
  const selected = ringTypes.find(({ type }) => type === selectedType);
  if (!selected) return null;

  return (
    <S.MapOverlayCard aria-label="Anéis do radar">
      <div className="flex flex-col gap-3 p-3">
        <div className="flex flex-col gap-1">
          <span
            id="ring-type-label"
            className="text-xs font-bold text-slate-700"
          >
            Anéis do tipo de veículo
          </span>
          <div
            role="radiogroup"
            aria-labelledby="ring-type-label"
            className="grid grid-cols-2 gap-1 rounded border border-slate-200 bg-slate-50 p-1"
          >
            {ringTypes.map(({ type }) => (
              <S.SegmentButton
                key={type}
                type="button"
                role="radio"
                aria-checked={type === selectedType}
                $active={type === selectedType}
                onClick={() => onSelectType(type)}
              >
                Tipo {type}
              </S.SegmentButton>
            ))}
          </div>
        </div>
        <ol
          aria-label={`Anéis do tipo ${selected.type}`}
          className="flex flex-col gap-1 text-xs text-slate-700"
        >
          {selected.rings.map((ring, index) => (
            <li key={ring} className="flex items-center gap-2">
              <S.RingSwatch aria-hidden="true" $arrival={index === 0} />
              <span className="font-bold">{formatKm(ring)}</span>
              {index === 0 ? (
                <span className="text-slate-500">chegada</span>
              ) : null}
            </li>
          ))}
        </ol>
        <details className="text-xs text-slate-600">
          <summary className="cursor-pointer font-semibold">
            {selected.isDefault
              ? 'Veículos do tipo (e os não listados)'
              : 'Veículos do tipo'}
          </summary>
          <p className="mt-1">{selected.vehicleTypes.join(', ')}</p>
        </details>
      </div>
    </S.MapOverlayCard>
  );
};
